import React from 'react';

const NewDropDownIcon = ({ size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M11.9467 5.95312H7.79335H4.05335C3.41335 5.95312 3.09335 6.72646 3.54668 7.17979L7.00002 10.6331C7.55335 11.1865 8.45335 11.1865 9.00668 10.6331L10.32 9.31979L12.46 7.17979C12.9067 6.72646 12.5867 5.95312 11.9467 5.95312Z"
      fill="#646567"
    />
  </svg>
);

export default NewDropDownIcon;
